import { Sentry } from "../..";
import { toErrorWithMessage } from "../../utils/ErrorRepacker";
import { retryPromise } from "../../utils/PromiseUtils";
async function parseBodyAsText(response) {
    if (response === undefined) {
        return Promise.resolve("undefined");
    }
    try {
        return response.text();
    }
    catch (err) {
        return Promise.resolve(`error: ${err}`);
    }
}
// TODO: throw exceptions on network failure
/**
 * RPC Service for interacting with the backend.
 */
export class RestaumaticRPCService {
    // TODO: url depending on envvars
    constructor(params) {
        this.url = params.url;
    }
    static async fetchJson(url, data) {
        let response;
        try {
            response = await retryPromise(() => fetch(url, data), 3, 100);
            if (!response.ok) {
                Sentry.captureExceptionWithExtra(new Error(`Fetch - ${response.statusText} ${response.statusText}`), {
                    url: url,
                    method: data.method,
                    status: response.status,
                });
                return null;
            }
            return (await response.json());
        }
        catch (err) {
            const error = toErrorWithMessage(err);
            if (err instanceof SyntaxError) {
                // Unexpected token < in JSON
                const body = await parseBodyAsText(response);
                Sentry.captureExceptionWithExtra(new Error(`Fetch - json parsing failed: ${error.message}`), {
                    url: url,
                    method: data.method,
                    errorMsg: error.message,
                    error: err,
                    body: body,
                    encodedBody: btoa(body),
                });
            }
            else {
                Sentry.captureExceptionWithExtra(new Error(`Fetch - network error: ${error.message}`), {
                    url: url,
                    method: data.method,
                    errorMsg: error.message,
                    error: err,
                });
            }
        }
        return null;
    }
    async post(path, data) {
        return RestaumaticRPCService.fetchJson(this.url + path, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(data),
        });
    }
    /**
     * Perform a RPC request to Restaumatic backend.
     * Throws RPCError when a RPC error response is received.
     */
    async rpc(method, params) {
        const response = await this.post(`/api/v1/sites/rpc?${method}`, {
            params,
            method,
            id: "1",
        });
        if (response === null) {
            return null;
        }
        if ("error" in response) {
            const { code, message, data } = response.error;
            const dataStr = data !== undefined ? `, data: ${data}` : "";
            Sentry.captureException(new Error(`RPCError[${code}]: ${message}${dataStr}`));
            return null;
        }
        return response.result;
    }
    async rpc2(method, params) {
        return await this.post(`/api/v1/sites/rpc/${method}`, params);
    }
}
